import {app} from './app'
import {createI18n} from 'vue-i18n'
import {createHead} from '@vueuse/head'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import './registerServiceWorker'
import router from './router'
import axios from "axios";
import iframeResize from 'iframe-resizer/js/iframeResizer';

import store from './store'

import '@moeinmdn/mixitweb-front-modules/src/plugin/class/axios';

axios.defaults.baseURL = 'https://api.diamondnr.ir/api/';

import ToastPlugin from 'vue-toast-notification';

app.use(ToastPlugin);
import './scss/custom.scss'

import 'bootstrap-icons/font/bootstrap-icons.css'

require('bootstrap')
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/MainRequirementsV3'

const head = createHead()

app.directive('resize', {
    mounted(el) {
        iFrameResize({log: false}, el)
    },
})

// ..
AOS.init();


import {translations as fa} from './views/fa/Translation';  let messages = { ...fa, };


export const i18n = createI18n({
    locale: 'fa',
    fallbackLocale: 'fa',
    messages
})


store.dispatch("Authentication/attemptLogin").then(async (r) => {
    await store.dispatch('SiteServiceManager/isProjectExpire')
    await store.dispatch("Language/getLanguages");
    await store.dispatch('SiteInfo/getSiteInfos')
    if (await store.getters['User/isAuthenticated']) {
        await store.dispatch("ShoppingCart/userOrderUnpaid");
    }
    app.use(store).use(head).use(i18n).use(router).mount('#app')
})
    .catch(async(err) => {
        await store.dispatch("Language/getLanguages");
        await store.dispatch('SiteInfo/getSiteInfos')
        app.use(store).use(head).use(i18n).use(router).mount('#app')
    })
